
import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';

import './daily-news-batch-manager.css';

class DailyNewsBatchManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isLoading: true,
    };

    this.getCandidates(props);
  }

  getCandidates(props) {
    DailyNewsService.getBatchManagerCandidates(props.location.search)    
      .then((candidates) => {
        this.setState({ 
          candidates: candidates.map(c => ({
            ...c,
            approved: false
          })),
          isLoading: false
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getOnChange = (url) => {
    return () => {
      this.setState((prevState) => {
        return {
          candidates: prevState.candidates.map(candidate => {
            const additionals = {};

            if (candidate.url === url) {
              additionals.approved = !candidate.approved;
            }

            return {
              ...candidate,
              ...additionals
            };
          })
        }
      })
    }
  }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} height='150px'/>;
  }

  onSave = () => {
    this.setState({
      isLoading: true,
    });
    
    DailyNewsService.saveBatchManagerCandidates(this.state.candidates)    
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getClapsSection(claps) {
    //'12 reaction | 10 comments' -> ['12', '10']
    const grade = claps.match(/\d+/g).reduce((acc, num) => acc + +num, 0);
    const fontSize = Math.max(18, 18 + (grade - 10) / 2);
    return <div style={{fontSize: `${fontSize}px`}}>{ claps }</div>;
  }

  render() {
    const generalFields = ['creator', 'publication', 'time', 
      'tags'];
    
    let body = 'Processing...';
    if (this.state && this.state.candidates && !this.state.isLoading) {
      body = (
        <div>  
          <input type='button' value='Save' onClick={this.onSave}/>

          <section>
            {
              this.state.candidates.map((candidate, i) => 
                <div key={candidate.url} 
                  className={(!candidate.approved && 'hide') || ''}
                  onClick={this.getOnChange(candidate.url)}
                  >
                  <div><label>{i + 1} out of {this.state.candidates.length}</label></div>

                  { this.getImg(candidate.img) }

                  { candidate.claps && this.getClapsSection(candidate.claps) }

                  { candidate.title && <h4>{candidate.title}</h4> }
                  <b><h5>{ candidate.universalTagName }</h5></b>

                  { candidate.text && <div dangerouslySetInnerHTML={{ __html: candidate.text}} /> }
                  URL: { 
                    <a 
                      href={candidate.url} 
                      style={{backgroundColor: ['dev.to', 'medium.com', 'youtube.com'].find(x=>candidate.url.indexOf(x) !== -1) ? '' : 'lightpink' }}>
                        {candidate.url}
                    </a>
                  }

                  {
                    generalFields.map(field => (<div key={field}>{candidate[field]}</div>))
                  }

                  {/* 
                  </div>
                  
                  { post.grade && <div><label>Grade: {post.grade}</label></div> }

                  <img src={post.imgUrl || ''} />

                  <div className='post-paragraphs'>
                    {post.paragraphs.length > 0 && post.paragraphs[0]}
                  </div>

                  <div>
                    <label>url:</label>
                    <i>{post.url || ''}</i>

                    <span className='direct-link'><a href={post.url} target='_blank'>Direct Link</a></span>
                  </div>

                  <div>
                    <label>SourceUrl:</label>
                    <i>{post.sourceUrl || ''}</i>

                    <span className='direct-link'><a href={post.sourceUrl} target='_blank'>Direct Link</a></span>
                  </div> */}

                  {/* {
                    generalFields.map(field => candidate[field]).filter(x=>x).join(' | ')
                  } */}


                <hr/>
              </div>
              )
            }
          </section>

          <input type='button' value='Save' onClick={this.onSave}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page daily-news-batch-manager'>
        {body}
      </section>
    );
  }
}

export default DailyNewsBatchManager;
